import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { DeleteParticipantBehaviourRecording } from '../mutations/deleteParticipantBehaviourRecording.mutation';
import type {
  DeleteParticipantBehaviourRecordingMutation,
  DeleteParticipantBehaviourRecordingMutationVariables,
} from '../types';

export const useDeleteParticipantBehaviourRecordingMutation = (
  options?: MutationOptions<
    DeleteParticipantBehaviourRecordingMutation,
    DeleteParticipantBehaviourRecordingMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(DeleteParticipantBehaviourRecording), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
